module.exports = "<ul class=\"nav nav-tabs\">\n    <li role=\"presentation\" ui-sref-active=\"active\" ng-class=\"{'disabled': object === null}\">\n        <a ui-sref=\".user\" ng-bind=\"object.title || 'User'\"></a>\n    </li>\n</ul>\n<div class=\"blnd-tab-content\"><div ui-view></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/templates/detail.section.html
// module id = 785
// module chunks = 0